'use strict';

var baseCore = require('integrations/product/base');
baseCore.sizeChart = function() {
    $('body').on('click', '.size-chart .size-chart-launcher', event => {
        event.preventDefault();
        var url = $(event.target).attr('href');
        var productId = $(event.target).closest('.product-detail').attr('data-pid');
        var $sizeChartModal = $('.modal[data-product=' + productId + ']');
        var $modalBody = $sizeChartModal.find('.modal-body .size-chart-content');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'html',
            success: function (data) {
                $modalBody.html(data);
            }
        });

        //if the sizechart is from a quickview append after all the modal-backdrops
        if ($(event.target).parents('.product-quickview').length) {
            var $sizeChartContainer = $(event.target).closest('.size-chart');

            $sizeChartModal.appendTo('body');
            $sizeChartModal.on('hide.bs.modal', event => {
                $sizeChartModal.appendTo($sizeChartContainer);
            });
        }
        $sizeChartModal.modal('show');
    });

    $('body').on('click', '#sizeChartModal .close', event =>  {
        $(event.target).closest('#sizeChartModal').modal('hide');
    });
}

baseCore.updateAttribute = function() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
        // CLIENT MOD: Don't update the size chart modal after selecting variant because the size chart is linked to the master product
        // response.container.find('#sizeChartModal').attr('data-product', response.data.product.id);

        //Quickview
        if ($('.modal.show .product-quickview>.bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else if ($('.set-items').length) {
            response.container.find('.product-id').text(response.data.product.id);
        } else if ($('.modal.show .product-quickview').length) {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
            $('.modal.show .full-pdp-link').attr('href', response.data.product.selectedProductUrl);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        //Main PDP
        } else if ($('.product-detail>.bundle-items').length) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
        } else if ($('.product-set-detail').eq(0)) {
            response.container.data('pid', response.data.product.id);
            response.container.find('.product-id').text(response.data.product.id);
            response.container.find('.add-to-cart').data('pid', response.data.product.id);
        } else {
            $('.product-detail .add-to-cart').data('pid', response.data.product.id);
            $('.product-id').text(response.data.product.id);
            $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
        }
    });
}

// Modified to add classes for availability messages
baseCore.methods.updateAvailabilityProcess = function(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div class="' + response.resources.info_selectforstock.toLowerCase().replace(/ /g, '-') + '">' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div class="' + message.toLowerCase().replace(/ /g, '-') + '">' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Updates media modal with PDP main images and videos from response
 * @param {Object[]} images - Array of large product images,along with related information
 * @param {jQuery} videos - Array of videos for the product
 */
baseCore.methods.updateMediaModal = function (images, videos) {
    var mediaModal = $('#productMediaModal');
    var photoContainer = mediaModal.find('.photo-container');
    var videoContainer = mediaModal.find('.videos-container');
    var videoTab = mediaModal.find('.video-tab');

    if (!videos || videos.URLs.length === 0) {
        videoTab.addClass('d-none');
        videoContainer.addClass('d-none');
    } else {
        videoContainer.removeClass('d-none');
        videoTab.removeClass('d-none');
        videoContainer.empty();
        videos.URLs.forEach(URL => {
            var $videoContainer = $('<div></div>');
            var $videoElement = $(URL);
            $videoContainer.attr({ 'class': 'position-relative video-container d-flex justify-content-center' });

            $videoContainer.append($videoElement[0]);
            videoContainer.append($videoContainer[0]);
        });
    }

    if (images) {
        photoContainer.empty();
        images.large.forEach(image => {
            var $imageElement = $('<img/>');
            $imageElement.attr({
                'src': image.absURL,
                'alt': image.alt + 'image number ' + (parseInt(image.index) + 1).toFixed(0),
                'class': 'd-block img-fluid zoomImg',
                'itemprop': 'image',
                'role': 'presentation'
            });

            photoContainer.append($imageElement[0]);
        });
    }
}

/**
 * Updates slider for PDP main images and thumbnails from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
baseCore.methods.createSlider = function (images, assets, videos, $productContainer) {
    var $sliderContainers = $productContainer.find('.slider-container');
    var data = images !== null ? {images} : null;
    data.assets = assets || null;
    data.videos = videos;

    // Reversing order in which to update sliders so that thumbnails get initialized first
    $($sliderContainers.get().reverse()).each((index, sliderContainer) => {
        var $slider = $(sliderContainer).find('.slider');

        // MARTIN MOD : carry through the no-zoom behavior from the previous variation
        data.zoom = $slider.find('.no-zoom').length === 0;

        $slider.trigger('slider:update', data);
    });
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
baseCore.methods.handleVariantResponse = function(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVariant;
    var isSetItem = $productContainer.hasClass('product-set-item-detail') ? true : false;

    if (response.product.variationAttributes) {
        baseCore.methods.updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVariant = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVariant) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);
            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
        }
    }

    var videos = null;
    var videoThumbnails = [];
    if (response.product.videoURLs) {
        response.product.videoThumbnail1 ? videoThumbnails.push(response.product.videoThumbnail1) : ''
        response.product.videoThumbnail2 ? videoThumbnails.push(response.product.videoThumbnail2) : ''
        response.product.videoThumbnail3 ? videoThumbnails.push(response.product.videoThumbnail3) : ''
        response.product.videoThumbnail4 ? videoThumbnails.push(response.product.videoThumbnail4) : ''
        var videos = {
            URLs: response.product.videoURLs,
            thumbnails: videoThumbnails
        }
    }

    // Update primary images
    var primaryImages = response.product.images;
    var pdpGalleryAssets = response.product.pdpGalleryAssets;
    var $oldWishlistIcon = $productContainer.find('div.slide .wishlist-toggle-product').first().clone(true);

    baseCore.methods.createSlider(primaryImages, pdpGalleryAssets, videos, $productContainer);
    baseCore.methods.updateMediaModal(primaryImages, videos);
    // if variant is a product set item, update the sample image
    if (isSetItem) {
        $productContainer
            .find('.product-set-item-main-image')
            .attr('src', primaryImages.large[0].url)
            .attr('alt', primaryImages.large[0].alt);
    }

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    baseCore.methods.updateAvailabilityProcess(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty().html(baseCore.methods.getAttributesHtml(response.product.attributes));

    // Update wishlist
    if ($oldWishlistIcon && $oldWishlistIcon.length) {
        var $newWishlistIcon = $oldWishlistIcon;
        $newWishlistIcon.attr('data-wishlistpid', response.product.wishlistpid);

        //Make heart icon accurate
        var wishlist = require('core/wishlist/components/helpers.js');
        wishlist.updateLinkData($newWishlistIcon);

        var $newSliderMainImages = $productContainer.find('div.primary-images-main div.slide img');
        $newSliderMainImages.each((_i, newImage) => {
            var $newImage = $(newImage);
            $newImage.after($newWishlistIcon.clone(true));
        });
    }
}

module.exports = baseCore;